module.exports = __webpack_public_path__ + "static/media/plus-blue.4b51cd11.svg";